import {ButtonComponent, ButtonProps} from "@/components/button/Button.types.ts";
import classNames from "classnames";
import React, {ComponentPropsWithoutRef, ElementType, forwardRef} from "react";
import styles from "./Button.module.scss";

export const Button: ButtonComponent = forwardRef(
  <T extends ElementType = "button">(
    {as, variant = "primary", size = "small", typography = "normal", className, children, ...rest}: ButtonProps<T>,
    ref: React.ForwardedRef<T>
  ) => {
    const Element = as || "button";
    const classes = classNames(styles[variant], styles[size], styles[typography], className);
    const elementProps = {
      ...(rest as ComponentPropsWithoutRef<T>),
      className: classes,
      ...(Element === "button" && !rest.type ? {type: "button"} : {}),
    };
    return (
      <Element ref={ref as React.Ref<T>} {...elementProps}>
        {children}
      </Element>
    );
  }
) as ButtonComponent;

export default Button;
